<template>
  <section class="legacy-print-options" aria-labelledby="legacy-options-title">
    <div class="legacy-options-heading">
      <span class="etq-panel-kicker">Mesmo cenário da impressão real</span>
      <h6 id="legacy-options-title">Opções da tela Gerar etiquetas</h6>
      <p>
        Marque aqui as mesmas opções que o usuário escolherá ao imprimir. A
        prévia e a impressão teste usarão exatamente esta combinação.
      </p>
    </div>

    <div class="legacy-options-grid">
      <label
        v-for="option in optionsList"
        :key="option.key"
        :class="[
          'legacy-option-row',
          { subordinate: option.subordinate, disabled: isDisabled(option) },
        ]"
        :data-print-option="option.key"
      >
        <span>
          <strong>{{ option.label }}</strong>
          <small v-if="option.help">{{ option.help }}</small>
        </span>
        <b-form-checkbox
          switch
          :checked="Boolean(value[option.key])"
          :disabled="isDisabled(option)"
          :aria-label="option.label"
          @change="$emit('change', { key: option.key, enabled: $event })"
        ></b-form-checkbox>
      </label>
    </div>

    <div v-if="value.considerar_codigo_interno" class="code-origin-note">
      <i class="fas fa-info-circle"></i>
      <span>
        O código interno substitui a referência e o EAN ao ser ligado. Com
        <strong>somente numeração</strong>, ele sai como texto, sem barras.
      </span>
    </div>

    <div class="custom-print-text">
      <label for="etiqueta-texto-personalizado">Texto personalizado</label>
      <input
        id="etiqueta-texto-personalizado"
        class="form-control form-control-sm"
        type="text"
        maxlength="150"
        :value="customText"
        placeholder="Texto informado na hora da impressão"
        @input="$emit('update:custom-text', $event.target.value.slice(0, 150))"
      />
      <small>{{ String(customText || "").length }}/150 caracteres</small>
    </div>
  </section>
</template>

<script>
export default {
  name: "LegacyPrintOptions",
  props: {
    value: {
      type: Object,
      required: true,
    },
    customText: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      optionsList: [
        { key: "cod_barras", label: "Gerar código de barra" },
        { key: "preco", label: "Gerar preço de venda" },
        { key: "imprimir_logo", label: "Impressão da logo" },
        { key: "considerar_referencia", label: "Considerar referência" },
        {
          key: "considerar_codigo_interno",
          label: "Considerar código interno",
        },
        {
          key: "codigo_interno_somente_numeracao",
          label: "Utilizar somente numeração (código interno)",
          subordinate: true,
          requiresInternalCode: true,
        },
        { key: "valor_por_kg", label: "Gerar valor por KG" },
      ],
    };
  },
  methods: {
    isDisabled(option) {
      return Boolean(
        option.requiresInternalCode && !this.value.considerar_codigo_interno
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.legacy-print-options {
  margin: 14px 0;
  padding: 13px;
  border: 1px solid #e7e3f5;
  border-radius: 10px;
  background: #fbfaff;
}

.legacy-options-heading h6 {
  margin: 3px 0 4px;
  font-size: 13px;
  font-weight: 800;
  color: #25213b;
}

.legacy-options-heading p {
  margin: 0 0 11px;
  color: #78738c;
  font-size: 11px;
  line-height: 1.45;
}

.legacy-options-grid {
  display: grid;
  gap: 1px;
  overflow: hidden;
  border: 1px solid #ebe8f4;
  border-radius: 8px;
  background: #ebe8f4;
}

.legacy-option-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 42px;
  margin: 0;
  padding: 7px 9px;
  background: #ffffff;
  cursor: pointer;
}

.legacy-option-row > span {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.legacy-option-row strong {
  color: #403b53;
  font-size: 11px;
  line-height: 1.3;
}

.legacy-option-row small {
  color: #8a849d;
  font-size: 9px;
}

.legacy-option-row.subordinate {
  padding-left: 20px;
  background: #f8f7fc;
}

.legacy-option-row.disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.code-origin-note {
  display: flex;
  gap: 7px;
  margin-top: 9px;
  padding: 8px 9px;
  border-radius: 7px;
  background: #eef8ff;
  color: #49718b;
  font-size: 10px;
  line-height: 1.4;
}

.code-origin-note i {
  margin-top: 2px;
  color: #3699ff;
}

.custom-print-text {
  margin-top: 12px;
}

.custom-print-text label {
  display: block;
  margin-bottom: 5px;
  color: #403b53;
  font-size: 11px;
  font-weight: 700;
}

.custom-print-text small {
  display: block;
  margin-top: 4px;
  text-align: right;
  color: #9a95ab;
  font-size: 9px;
}
</style>
